import { render, staticRenderFns } from "./TableRole.vue?vue&type=template&id=06fb0504&scoped=true"
import script from "./TableRole.vue?vue&type=script&lang=js"
export * from "./TableRole.vue?vue&type=script&lang=js"
import style0 from "./TableRole.vue?vue&type=style&index=0&id=06fb0504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb0504",
  null
  
)

export default component.exports